import React, { useContext, useEffect, useState } from 'react'
// import './App.css'
import { BrowserRouter } from 'react-router-dom'
import RootContainer from 'containers/RootContainer'
import ModalSowCountry from 'containers/homeContainers/modalShowCountry'
import localforage from 'localforage'
import UserContext from 'contexts/UserContext'
import { updateCountry } from 'requests/user'
import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import ModalFirstOpendTuto from 'rewards/modalFirstOpendTuto'

const AppContent = () => {
  const navigate = useNavigate()

  const { user, setUser } = useContext(UserContext)

  const [showModalCountry, setShowModalCountry] = useState(false)
  const [destinationDefaultCountry, setDestinationDefaultCountry] = useState('')
  const [isOpenfirstModal, setIsOpenfirstModal] = useState(false)
  const [isCompletedKYC, setIsCompletedKYC]= useState(false)
useEffect(()=>{
  if(user?.user.destinationDefaultCountry===undefined)
  setDestinationDefaultCountry('')
  
},[user])

// useEffect(() => {
//   const isTutoOpened = user?.user?.game?.isTutoOpened

//   if (isTutoOpened !== undefined) {
//     setIsOpenfirstModal(!isTutoOpened)
//   }
// }, [user?.user?.game?.isTutoOpened])

  useEffect(() => {
    if (user?.user?.destinationDefaultCountry === '' || user?.user?.destinationDefaultCountry === undefined) {
      setShowModalCountry(true)
    } else {
      setShowModalCountry(false)
    }
  }, [user])

  const updateCountryUser = async (isCompletedKYC: boolean) => {
    const id = user?.user?._id
    const token = user?.token?.accessToken
    if (!id || !token) {
    console.error('Utilisateur ou token manquant')
    return
  }
    try {
      setIsCompletedKYC(isCompletedKYC)
      const response = await updateCountry(id, token, destinationDefaultCountry)
      if (response?.success) {
        if (user) {
          ;(setUser({ token: user?.token, success: true, user: response.user }),
            localforage.setItem('auth', JSON.stringify({ token: user?.token, success: true, user: response.user })))
        }
        setShowModalCountry(false)

        if (isCompletedKYC) {
          navigate('/personalinformation')
          return
        }
          setIsOpenfirstModal(true)
          navigate('/')

    }
    } catch (error) {
      console.error('Error updating:', error)
    }
  }

  return (
    <>
      {user?.user.destinationDefaultCountry===undefined
      &&
        <ModalSowCountry
        isOpen={showModalCountry}
        updateCountryUser={updateCountryUser}
        setDestinationDefaultCountry={setDestinationDefaultCountry}
        destinationDefaultCountry={destinationDefaultCountry}
      />}

      {user?.user?.destinationDefaultCountry && isOpenfirstModal && isCompletedKYC===false && (
        <ModalFirstOpendTuto setIsOpenModal={setIsOpenfirstModal} isOpenModal={isOpenfirstModal} />
      )}

      {/* <RootContainer /> */}
    </>
  )
}

const App = () => {
  return (
    <BrowserRouter>
      <ToastContainer />
      <AppContent />

      <RootContainer />
    </BrowserRouter>
  )
}

export default App
